/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import localeDataDefault from '../i18n/locales/en.json';
import {LOCALE_CHANGE} from '../_actions/i18n.actions';

export const DEFAULT_LANGUAGE = 'en';

export const INITIAL_STATE = {
    locale: DEFAULT_LANGUAGE,
    messages: Object.assign({}, localeDataDefault)
};

// TODO Revist following logic as it would cause problems at runtime
export default function i18nChange(state = INITIAL_STATE, action) {
    switch (action.type) {
        case LOCALE_CHANGE: {
            let localeData = {};
            if (action.payload) {
                localeData = require('../i18n/locales/' + action.payload + '.json');
            }
            return ({
                locale: action.payload,
                messages: Object.assign({}, localeDataDefault, localeData)
            });
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/i18n.reducer.js